import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './Login';
import Logout from './Logout';
import AuthResetPassword from './AuthResetPassword';
import AuthInvite from './AuthInvite';
import AuthTwoFactor from './AuthTwoFactor';
import AuthComplete from './AuthComplete';
import AuthFailure from './AuthFailure';
import RequireAuth from 'auth/RequireAuth';
import SelectWorkspace from 'containers/SelectBranch';

export default function AuthRoot() {
	return (
		<Routes>
			<Route path="/" element={<Navigate to="/auth/login" />} />
			<Route path="/login" element={<Login />} />
			<Route path="/logout" element={<Logout />} />
			<Route path="/resetpassword" element={<AuthResetPassword />} />
			<Route path="/invite" element={<AuthInvite />} />
			<Route path="/verify" element={<AuthTwoFactor />} />
			<Route path="/complete" element={<AuthComplete />} />
			<Route path="/failure" element={<AuthFailure />} />
			<Route path="/selectworkspace" element={<RequireAuth><SelectWorkspace /></RequireAuth>} />
		</Routes>
	);
}